module.exports = __webpack_public_path__ + "static/media/Move Down Blue.1f158b6c.svg";